import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { FAQS } from '../data/site';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="w-full border-b border-ink-line bg-ink-soft pb-16 pt-8 sm:pb-24 sm:pt-12" data-id="element-38" data-mp="1l9o3aysf9hgz">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-39" data-mp="1gauuhjo2yen5">
        <div className="text-center" data-id="element-40" data-mp="2dz4xa0vox6fb">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand-orange" data-id="element-41" data-mp="2dy3iblbjzzsb">
            Parent questions
          </span>
          <h2 className="mt-3 text-3xl uppercase sm:text-4xl" data-id="element-42" data-mp="241gx2vfbf6pr">Everything you need to know</h2>
        </div>

        <dl className="mt-10 space-y-3" data-id="element-43" data-mp="1z25int2f8dbc">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className={`overflow-hidden rounded-2xl border bg-ink ${isOpen ? 'border-brand-orange/50' : 'border-ink-line'}`} data-id="element-44" data-mp="no08gibm777k" data-mpi={index}>
                <dt data-id="element-45" data-mp="uhal1vw8yss9">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-46" data-mp="ugirsrq4h755">
                    <span className="text-base font-semibold" data-id="element-47" data-mp="6qoigk50i0pn">{faq.question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-orange transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-48" data-mp="bj8484dus25j" />
                  </button>
                </dt>
                <AnimatePresence initial={false} data-id="element-49" data-mp="3jyrtksbel0fb">
                  {isOpen && <motion.dd initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-50" data-mp="3nya54xhc3z5h">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-white/70" data-id="element-51" data-mp="1frye7y6hiwpf">
                        {faq.answer}
                      </p>
                    </motion.dd>}
                </AnimatePresence>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}